import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'
import { FilterOptionsBody } from 'types/GlobalAttributeOptions'

// select all metrics
export const selectFilterOptions = createSelector(
  [(state: ApplicationState) => state.FilterOptionStore.data],
  (data) => data
)

export const selectAllAndLoading = createSelector(
  [
    // Input selectors:
    (state: ApplicationState) => state.FilterOptionStore.data,
    (state: ApplicationState) => state.FilterOptionStore.fetched
  ],
  (data, fetched): [FilterOptionsBody, boolean] => [data, !fetched]
)
